export const isBoolean = (x) => typeof x === "boolean";
